import { SaveType } from './reducers/AolSaveEventReducer';
import { NoonReportSectionEnum } from '../types/ViewModel/AolEnums';
import { useAolStore } from '../context/AolContext';
import { useVesselStore } from '../context/VesselContext';
import usePostUpdateAolSection from '../api/usePostUpdateAolSection';
import { SectionType } from '../types/ViewModel/AolSectionType';
import { AolDataItem } from '../types/ViewModel/AolItem';

export default () => {
    const { saveAolEvent, setSaveAolEvent } = useAolStore();
    const { selectedVessel } = useVesselStore();
    const { saveAolSection } = usePostUpdateAolSection();

    const triggerSaveEvent = (type: SaveType, section: NoonReportSectionEnum, aolDataItem: AolDataItem) => {
        // TODO: NULL-SAFETY - Missing null/undefined check for aolDataItem parameter
        if (!selectedVessel) return;
        setSaveAolEvent({ type, section, imoNumber: selectedVessel.imoNumber, aolDataItem });
    };

    const saveSection = (data: SectionType) => {
        // TODO: NULL-SAFETY - Missing null/undefined check for data parameter
        // TODO: NULL-SAFETY - Multiple nested property access without null checks on saveAolEvent.aolDataItem
        if (!saveAolEvent || !saveAolEvent.aolDataItem.aolItem?.portLogAolItem?.imosPortCallId) return;
        const noonReportId = saveAolEvent.aolDataItem.noonReport?.metadata.noonReportId;
        const aolDataItem = saveAolEvent.aolDataItem;

        saveAolSection(
            saveAolEvent.imoNumber,
            aolDataItem.indexInDay,
            aolDataItem.numberOfReportsInDay,
            aolDataItem.aolItem?.portLogAolItem.imosPortCallId,
            data,
            noonReportId
        );

        setSaveAolEvent(null);
    };
    return { saveAolEvent, triggerSaveEvent, saveSection };
};
